"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessLevelTypes = void 0;
var AccessLevelTypes;
(function (AccessLevelTypes) {
    AccessLevelTypes["Viewer"] = "Viewer";
    AccessLevelTypes["Editor"] = "Editor";
})(AccessLevelTypes || (exports.AccessLevelTypes = AccessLevelTypes = {}));
